import { userInfoSync } from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
const DOCUMENTS_DISABLE_DOWNLOAD_GATE = gate('BuyerExperience:SalesDocumentsDisableDownload');
export default (() => {
  const auth = userInfoSync();
  return Boolean(auth.gates.includes(DOCUMENTS_DISABLE_DOWNLOAD_GATE));
});